module.exports = __webpack_public_path__ + "static/points_list.3906c679.png";